import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { ApiManualBalance } from '@/rennovation/planning-view/types/api/manual-balance-response';
import { ManualBalanceApiService } from '@/rennovation/common/services/api/manualBalanceApiService';

const manualBalanceApi = new ManualBalanceApiService();

export const useManualBalanceStore = defineStore('manualBalance', () => {
	// ============================================
	// STATE
	// ============================================
	const balances = ref<ApiManualBalance[]>([]);
	const isLoading = ref(false);
	const error = ref<string | null>(null);

	// ============================================
	// GETTERS
	// ============================================
	const worktimeBalances = computed(() => balances.value.filter((b) => b.type === 'workTime' && !b.deleted));

	const balancesByDate = computed(() =>
		balances.value.reduce<Record<string, ApiManualBalance[]>>((acc, balance) => {
			const date = balance.day.dateString;
			if (!acc[date]) acc[date] = [];
			acc[date].push(balance);
			return acc;
		}, {})
	);

	// ============================================
	// ACTIONS
	// ============================================
	async function loadManualWorktimeBalances(user: string, month = ''): Promise<ApiManualBalance[]> {
		isLoading.value = true;
		error.value = null;
		try {
			const result = await manualBalanceApi.getManualWorktimeBalances(user, month);
			balances.value = result;
			return result;
		} catch (err) {
			error.value = err.response?.data?.message ?? err.message ?? 'Could not load manual work time balances.';
			return [];
		} finally {
			isLoading.value = false;
		}
	}

	return {
		// state
		balances,
		isLoading,
		error,
		// getters
		worktimeBalances,
		balancesByDate,
		// actions
		loadManualWorktimeBalances,
	};
});
